import $ from 'jquery';
import BaseClass from '../../libs/base/BaseClass';
import DoubleSubmitControlClass from './DoubleSubmitControlClass';

/**
 * 二重送信制御 管理
 */
export default class DoubleSubmitControlManagerClass extends BaseClass {
  constructor() {
    super();
    this.name = 'DoubleSubmitControlManagerClass';
  }

  onCreate() {
    // console.log(this.name + '::onCreate()');
    super.onCreate();
    const self = this;
    this.items = [];

    // submitボタンにdata-submit-ctrl属性を加えて使用する
    $('[data-submit-ctrl]').each((index, element) => {
      const buttonId = $(element).attr('data-submit-ctrl');
      const aDoubleSubmitControl = new DoubleSubmitControlClass($(element));
      self.items[buttonId] = aDoubleSubmitControl;
    });

    for (let k in this.items) {
      this.items[k].onCreate();
      this.items[k].on(this.items[k].EVENT_CHANGE, () => {
        this.onCheck(false);
      });
    }
  }
}
